import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { initGA, sendPageView } from './src/ga';

export const onClientEntry = () =>{
   // Initialize GA4 (gtag) + GTM on every full page load, before React.
   initGA();

   if(process.env.NODE_ENV === "production"){
     datadogRum.init({
       applicationId: "d51f82c8-9769-4c94-9ef8-b438595e9f54",
       clientToken: "pubd291aac5b67229d480462a2a3cb216a2",
       site: "datadoghq.eu",
       service: "d2c-eu-onboarding-fe",
       env: process.env.NODE_ENV,
       version: "1.0.0",
       sessionSampleRate: 100,
       sessionReplaySampleRate: 100,
       trackResources: true,
       trackUserInteractions: true,
       trackLongTasks: true,
       plugins: [reactPlugin({ router: false })],
       defaultPrivacyLevel: "allow"
     })
     datadogRum.startSessionReplayRecording()
   }
}

// Fires on the initial load and on every client-side route change.
export const onRouteUpdate = () => {
   sendPageView();
}
